export const ENV = {
	REACT_APP_BASE_API_URL: String(window._env_.REACT_APP_BASE_API_URL),
	REACT_APP_PERMISSION: String(window._env_.REACT_APP_PERMISSION),
	REACT_APP_GA: String(window._env_.REACT_APP_GA),
	REACT_APP_BACKGROUND_IMAGES: String(window._env_.REACT_APP_BACKGROUND_IMAGES),
};
